<nav class="navbar navbar-expand-md navbar-light homehunt_nav" *ngIf="appState.companyInfo$ | async as companyInfo">
  <div class="text-center no_property_img">
    <img src="../../../../../assets/images/spend.jpg" width="150" alt="property" class="opacity-80" />
    <div #errorContainer></div>
  </div>
</nav>
